export var BillingType;
(function (BillingType) {
    BillingType["zont"] = "zont";
    BillingType["asp"] = "asp";
})(BillingType || (BillingType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["yakassa"] = "yakassa";
    PaymentMethod["invoice"] = "invoice";
    PaymentMethod["auto_invoice"] = "auto_invoice";
})(PaymentMethod || (PaymentMethod = {}));
export const translate_payment_method = {
    bank_card: 'карты •••',
    yoo_money: 'ЮMoney',
    sberbank: 'SberPay',
    tinkoff_bank: 'Tinkoff Pay',
    sbp: 'СБП',
};
export function getAutoPaymentTranslate(auto_payment) {
    if (Object.keys(translate_payment_method).includes(auto_payment.payment_method_type)) {
        return `Подключён автоплатёж с ${translate_payment_method[auto_payment.payment_method_type]} ${auto_payment.last4 != null ? auto_payment.last4 : ''}`;
    }
    return `Подключён автоплатёж с карты ••• ${auto_payment.last4}`;
}
var BillingActionType;
(function (BillingActionType) {
    BillingActionType["top_up"] = "top_up";
    BillingActionType["charge"] = "charge";
    BillingActionType["start_billing"] = "start_billing";
    BillingActionType["buy_history"] = "buy_history";
    BillingActionType["gift_history"] = "gift_history";
    BillingActionType["refund"] = "refund";
    BillingActionType["set_post_pay"] = "set_post_pay";
    BillingActionType["gift_days"] = "gift_days";
    BillingActionType["buy_h2000plus_firmware"] = "buy_h2000plus_firmware";
    BillingActionType["buy_thermostat_for_socket_03"] = "buy_thermostat_for_socket_03";
    BillingActionType["buy_design_package"] = "buy_design_package";
    BillingActionType["prolong_sim"] = "prolong_sim";
    BillingActionType["sim_shipping"] = "sim_shipping";
    BillingActionType["set_credit_limit"] = "set_credit_limit";
    BillingActionType["noop"] = "noop";
    BillingActionType["inactivity_charge"] = "inactivity_charge";
    BillingActionType["write_off"] = "write_off";
    BillingActionType["upgrade_tariff"] = "upgrade_tariff";
    BillingActionType["downgrade_tariff"] = "downgrade_tariff";
    BillingActionType["cancel_tariff_downgrade"] = "cancel_tariff_downgrade";
    BillingActionType["reset_tariff"] = "reset_tariff";
    BillingActionType["manual_adjust"] = "manual_adjust";
    BillingActionType["free_sim_shipping"] = "free_sim_shipping";
    BillingActionType["upgrade_sim_tariff"] = "upgrade_sim_tariff";
    BillingActionType["downgrade_sim_tariff"] = "downgrade_sim_tariff";
    BillingActionType["cancel_sim_tariff_downgrade"] = "cancel_sim_tariff_downgrade";
    BillingActionType["reset_sim_tariff"] = "reset_sim_tariff";
    BillingActionType["cancel_operation"] = "cancel_operation";
})(BillingActionType || (BillingActionType = {}));
